/* LIX — Édition 2026 · scripts de marque
   1. En-tête transparent sur l’accueil → devient opaque et fixé après un léger défilement.
   2. Barre d’achat collante (fiche produit) → apparaît quand « Ajouter au panier » sort de l’écran
      et soumet le formulaire principal (même comportement, tiroir panier compris).
   Aucune dépendance ; se ré-initialise dans l’éditeur de thème (shopify:section:load). */
(function () {
  'use strict';

  function initHeader() {
    var body = document.body;
    if (!body.classList.contains('lix-transparent-home') || body.dataset.lixHeaderInit === '1') return;
    body.dataset.lixHeaderInit = '1';
    var ticking = false;
    var update = function () {
      body.classList.toggle('lix-scrolled', window.scrollY > 40);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-lix-sticky-atc]');
    if (!bar || bar.dataset.lixInit === '1') return;
    var form = document.querySelector('.product__info-container form[data-type="add-to-cart-form"]');
    if (!form) return;
    bar.dataset.lixInit = '1';
    var button = bar.querySelector('[data-lix-sticky-submit]');
    if (button && form.id) button.setAttribute('form', form.id);
    var target = form.querySelector('.product-form__submit') || form;
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }

  function init() {
    initHeader();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* Paliers de prix : le choix 1, 2 ou 3 sacs règle la quantité envoyée au panier. */
document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input || !input.matches || !input.matches('[data-lix-tiers] input[type="radio"]')) return;
  var quantity = input.closest('[data-lix-tiers]').querySelector('[data-lix-tiers-quantity]');
  if (quantity) quantity.value = input.value;
});